import React from "react";
import NumericInput from "./NumericInput";

export const FluentNumericInput = ({ value, onChange, min, max, step, disabled, precision, className, placeholder, defaultValue }) => {
    return (
        <NumericInput
            disabled={disabled}
            appearance="filled-lighter"
            value={value}
            onChange={(value) => {
                onChange(value)
            }}
            as="input"
            // size="small"
            className={className}
            min={min}
            max={max}
            placeholder={placeholder}
            defaultValue={defaultValue}
        />
    )
}